module.exports = __webpack_public_path__ + "static/media/480.89fc9156.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-seed/dark/480.png
// module id = 2414
// module chunks = 2